<div>
  <div class="modal-header">{{'dso-selector.'+ action + '.' + objectType.toString().toLowerCase() + '.head' | translate}}
    <button type="button" class="btn-close" (click)="close()" aria-label="Close">
    </button>
  </div>
  <div class="modal-body">
    @if (header) {
      <span class="h5 px-2">{{header | translate}}</span>
    }
    <ds-authorized-collection-selector [currentDSOId]="dsoRD?.payload.uuid"
      [entityType]="entityType"
      [types]="selectorTypes"
    (onSelect)="selectObject($event)"></ds-authorized-collection-selector>
  </div>
</div>
